import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "stat-cards" }
const _hoisted_2 = { class: "stat-card" }
const _hoisted_3 = { class: "stat-card-header" }
const _hoisted_4 = { class: "stat-value" }
const _hoisted_5 = { class: "stat-card" }
const _hoisted_6 = { class: "stat-card-header" }
const _hoisted_7 = { class: "stat-value" }
const _hoisted_8 = { class: "stat-card" }
const _hoisted_9 = { class: "stat-card-header" }
const _hoisted_10 = { class: "stat-value" }
const _hoisted_11 = { class: "stat-sub" }

import BaseIcon from "@/components/ui/BaseIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserStatCards',
  props: {
    totalLogins: {},
    lastLogin: {},
    isLoggedIn: { type: Boolean },
    sessions: {}
  },
  setup(__props: any) {



function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BaseIcon, {
          name: "arrow-right",
          size: 14
        }),
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "stat-label" }, "Total Logins", -1))
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.totalLogins), 1),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "stat-sub" }, "+12 this week", -1))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(BaseIcon, {
          name: "clock",
          size: 14
        }),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "stat-label" }, "Last Active", -1))
      ]),
      _createElementVNode("div", _hoisted_7, _toDisplayString(formatDate(__props.lastLogin)), 1),
      _createElementVNode("div", {
        class: _normalizeClass(['stat-sub', __props.isLoggedIn && 'stat-sub--green'])
      }, _toDisplayString(__props.isLoggedIn ? "Online now" : "Offline"), 3)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(BaseIcon, {
          name: "activity",
          size: 14
        }),
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "stat-label" }, "Sessions", -1))
      ]),
      _createElementVNode("div", _hoisted_10, _toDisplayString(__props.sessions), 1),
      _createElementVNode("div", _hoisted_11, _toDisplayString(Math.min(__props.sessions, 3)) + " active", 1)
    ])
  ]))
}
}

})